(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SettingController', SettingController);

    SettingController.$inject = ['__config', '$scope', '$state', 'ParseLinks', 'AlertService', 'CompanyCustomerCustom', "CompanyInfoQuery", "ServiceItemCustom", "$translatePartialLoader", "$translate", "ServiceCategoryCustom"];

    function SettingController(__config, $scope, $state, ParseLinks, AlertService, CompanyCustomerCustom, CompanyInfoQuery, ServiceItemCustom, translatePartialLoader, translate, ServiceCategoryCustom) {
        var vm = this;
        vm.__config = __config;
        vm.settingFormSection = '';
        vm.setFormSection = setFormSection;

        function setFormSection(p) {
            vm.settingFormSection = p;
        }
    }
})();

